module.exports = __webpack_public_path__ + "img/comment-bg.b01d8426.png";